import React, { useEffect, useState } from 'react';
import {
  createSingleArtisanJobAction,
  updateArtisanApplicantStatusAction
} from '../../../../../modules/artisanJobs/Actions';
import {
  artisanJobsSelector,
  artisanJobsIsLoadingSelector,
  artisanJobsCountSelector,
  searchValueSelector
} from '../../../../../modules/artisanJobs/Selectors';
import { connect } from 'react-redux';
import List from '../../../../../components/Lists/List';
import ListItem from '../../../../../components/Lists/ListItem';
import InfiniteScroll from 'react-infinite-scroll-component';
import getLangData from '../../../../../utils/getLangData';
import { Table } from 'react-bootstrap';
import { Link, useHistory } from 'react-router-dom';
import CApllicantItem from '../../../../../components/UI/Card/CApllicantItem';
import CApplicantDetail from '../../../../../components/UI/Card/CApplicantDetail';
import Cookies from 'js-cookie';

const ArtisanJobsList = props => {
  const {
    artisanJobs,
    isLoading,
    getArtisanJob,
    artisanJobsCount,
    searchValue,
    currentUser,
    singleJob,
    jobId,
    updateStatus
  } = props;

  const artisanId = currentUser?.profiles?.artisan?._id;
  const [activeApplicant, setActiveApplicant] = useState({});

  useEffect(() => {
    if (jobId) getArtisanJob(jobId);
  }, [jobId]);

  const history = useHistory();
  const goBack = () => {
    history.goBack();
  };
  const dir = Cookies.get('lang')
  console.log(singleJob, 'singleJob');
  const date1 = new Date();
  const date2 = new Date(singleJob?.createdAt);
  const diffTime = Math.abs(date2 - date1);
  const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));

  useEffect(() => {
    if (
      Object.keys(activeApplicant).length === 0 &&
      singleJob?.applicants?.length > 0
    )
      setActiveApplicant(singleJob?.applicants[0]);
  }, [singleJob]);

  return (
    <>
      <div className='body' style={{ width: '100%' }}>
        {/* Content */}
        <div className='container'>
          {/* Content BEGIN */}
          <div className='edit row block--container my-5'>
            <div className='col-12'>
              <div className='row actions--nav'>
                <div className='col back--action'>
                  <Link onClick={goBack} to=''>
                    {/* <em className="icon-arrow-left-warshatna" /> */}
                    <i
                      className={`fas fa-chevron-${dir == 'ar' ? 'right' : 'left'}`}
                      style={{
                        padding: '8px',
                        border: '1px solid #000000',
                        borderRadius: '100%',
                        marginRight: '12px',
                        marginLeft: '12px'
                      }}
                    ></i>
                    {getLangData().buttons.back}
                  </Link>
                  <span>Job Details</span>
                </div>
              </div>
              {/* Content */}
              <div className='row mt-5'>
                {/* Job Details */}
                <div className='col-12 row job--details inner'>
                  <div className='col-12 col-md-8 mb-3'>
                    <div className='date'>{diffDays} days ago</div>
                    <div className='title'>{singleJob?.jobTitle}</div>
                    <div className='subtitle'>
                      {singleJob?.applicants?.length} Applicants
                    </div>
                    <div className='subtitle'>Full-Time</div>
                    <div className='salary'>$32k - $74k/year</div>
                    <div className='salary'>
                      {singleJob?.yearsOfExperience} Years Of Experience
                    </div>
                  </div>
                  <div className='col-12 content'>
                    <div className='inner'>
                      <p>{singleJob?.jobDescription}</p>
                    </div>
                    {/* <div className='cover'>
                      <a href='#' className='view--more'>
                        View More
                      </a>
                    </div> */}
                  </div>
                </div>
                {/* Jobs List */}
                <div className='row block--container m-0 my-5'>
                  {/* Header */}
                  <div className='header col-8'>
                    <h2>Job Applicants</h2>
                  </div>
                  {/* Content */}
                  <div className='col-12 row'>
                    {/* Jobs List */}
                    <div className='col-6'>
                      <div className='jobs--container custom--scrollbar'>
                        {/* Item BEGIN */}
                        {singleJob?.applicants?.map((data, index) => (
                          <a
                            key={index}
                            onClick={() => {
                              setActiveApplicant(data);
                            }}
                          >
                            <CApllicantItem data={data} />
                          </a>
                        ))}

                        {/* Item END */}
                      </div>
                    </div>
                    {/* Job Details */}
                    <div className='col-6'>
                      <CApplicantDetail
                        singleJob={singleJob}
                        activeApplicant={activeApplicant}
                        jobId={jobId}
                        updateStatus={updateStatus}
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* Content END */}
        </div>
      </div>
    </>
  );
};

const mapStateToProps = (state, props) => {
  const jobId = props.match.params.id;
  return {
    jobId,
    singleJob: state.artisanJobs.singleJob,
    isLoading: artisanJobsIsLoadingSelector(state),
    artisanJobsCount: artisanJobsCountSelector(state),
    searchValue: searchValueSelector(state),
    currentUser: state?.users?.currentUser
  };
};

export default connect(mapStateToProps, {
  getArtisanJob: createSingleArtisanJobAction,
  updateStatus: updateArtisanApplicantStatusAction
})(ArtisanJobsList);
